// auth localstorage name
const STORAGE_PREFIX = `__avart_integral_msg`;
export const AUTH_TOKEN = `${STORAGE_PREFIX}_auth_token`;
export const AUTH_TOKEN_REFRESH = `${STORAGE_PREFIX}_auth_token_refreshed`;

export const UA = window.navigator.userAgent.toLowerCase();

export const BROWSER_TYPE = {
  App: UA.includes("avatar"),
  Weapp: UA.includes("miniprogram"),
  Wechat: UA.includes("micromessenger") && !UA.includes("miniprogram"),
  IsAndroid: UA.includes("android") || UA.includes("linux"),
  IsIOS: UA.includes("mac"),
};

export const VALIDATOR = {
  mobileReg: /^1[3456789]\d{9}$/,
};

export type Env = "dev" | "test" | "stg" | "prod";

// website domain
export const WEBSITE_DOMAIN: Record<Env, string> = {
  dev: "http://website.dev.internal.avatr.com:9080",
  test: "http://website.test.internal.avatr.com:9080",
  stg: "http://website.stg.internal.avatr.com",
  prod: "https://avatr.com",
};
